import { render, staticRenderFns } from "./NotificationsContainer.vue?vue&type=template&id=fa0991ee&scoped=true"
import script from "./NotificationsContainer.vue?vue&type=script&lang=js"
export * from "./NotificationsContainer.vue?vue&type=script&lang=js"
import style0 from "./NotificationsContainer.vue?vue&type=style&index=0&id=fa0991ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0991ee",
  null
  
)

export default component.exports